export function initOelfinder() {
    const _origFetch = window.fetch.bind(window);
    window.fetch = function (input, init = {}) {
        const url = typeof input === 'string' ? input : input.url;
        if (url && url.includes('/em/olyslager/')) {
            const headers = new Headers(init.headers || {});
            if (typeof siteCode !== 'undefined') headers.set('x-site-code', siteCode);
            if (typeof languageCode !== 'undefined') headers.set('x-language-code', languageCode);
            init = {...init, headers};
        }
        return _origFetch(input, init);
    };

    var WDWidgetBundle = function (t) {
        "use strict";
        const e = {
            title: "Find the right oil for your vehicle",
            your_vehcile: "Your vehicle",
            brand: "Brand",
            model: "Model",
            type: "Type",
            results: "View results",
            category: "Category"
        };

        class s extends HTMLElement {
            constructor() {
                super(), this._root = this.attachShadow({mode: "open"}), this._locale = this.getAttribute("locale") || "en", this._currentStep = 1, this._isLoading = !0, this._category = null, this._brand = null, this._model = null, this._type = null, this.base_api = "/em/olyslager/", this._translations = e, this._css = this.getAttribute("css_file"), this._category_id = this.getAttribute("category_id"), this._categories = []
            }

            static get observedAttributes() {
                return ["locale"]
            }

            connectedCallback() {
                this._root.innerHTML = `\n      <link href="${this._css}" rel="stylesheet">\n\n      <div class="wd-container">\n        <div class="spinner-container">\n          <div class="spinner"></div>\n        </div>\n\n        <div class="step-content">\n          <select name="category" id="category-select">\n            <option value="" disabled selected >${this._translations.category}</option>\n          </select>\n          <select name="brand" disabled id="brand-select">\n            <option value="" disabled selected >${this._translations.brand}</option>\n          </select>\n          <select name="model" disabled id="model-select">\n            <option value="" disabled selected >${this._translations.model}</option>\n          </select>\n          <select name="type" disabled id="type-select">\n            <option value="" disabled selected >${this._translations.type}</option>\n          </select>\n          <button disabled id="results-btn">${this._translations.results}</button>\n          <a style="display: none;" id="results">${this._translations.results}</a>\n        </div>\n      </div>\n    `, this._initializeComponents()
            }

            async _initializeComponents() {
                try {
                    if (await this._setTranslations(), await this._fetchCategory(), this._category_id && !Number.isNaN(this._category_id) && this._categories.includes(Number(this._category_id))) {
                        this._category = Number(this._category_id);
                        this._root.querySelector("#category-select").value = Number(this._category_id), this._fetchBrand()
                    }
                    this._addEventListeners()
                } catch (t) {
                }
            }

            async _setTranslations() {
                const t = await fetch(`${this.base_api}translations?language=${this._locale}`, {
                    method: "GET",
                    headers: {Accept: "application/json"}
                });
                if (t) {
                    const e = await t.json();
                    this._translations = e;
                    const s = this._root.querySelector("#results-btn"), i = this._root.querySelector("#results");
                    s.innerHTML = e.results, i.innerHTML = e.results
                }
            }

            _resetType() {
                const t = this._root.querySelector("#type-select");
                this._type = null, t.disabled = !0, t.value = ""
            }

            _resetModel() {
                const t = this._root.querySelector("#model-select");
                this._model = null, t.disabled = !0, t.value = ""
            }

            _resetBrand() {
                const t = this._root.querySelector("#brand-select");
                this._brand = null, t.disabled = !0, t.value = ""
            }

            _resetCategory() {
                const t = this._root.querySelector("#category-select");
                this._category = null, t.disabled = !0, t.value = ""
            }

            _resetResult() {
                const t = this._root.querySelector("#results-btn"), e = this._root.querySelector("#results");
                t.style.display = "block", e.style.display = "none"
            }

            _addEventListeners() {
                const t = this._root.querySelector("#category-select"), e = this._root.querySelector("#brand-select"),
                    s = this._root.querySelector("#model-select"), i = this._root.querySelector("#type-select");
                t.addEventListener("change", (async t => {
                    this._category = t.target.value, this._resetBrand(), this._resetModel(), this._resetType(), this._resetResult(), await this._fetchBrand()
                })), e.addEventListener("change", (async t => {
                    this._brand = t.target.value, this._resetModel(), this._resetType(), this._resetResult(), await this._fetchModel()
                })), s.addEventListener("change", (async t => {
                    this._model = t.target.value, this._resetType(), this._resetResult(), await this._fetchType()
                })), i.addEventListener("change", (async t => {
                    this._type = t.target.value, this._resetResult(), await this._fetchResult()
                }))
            }

            async _fetchCategory() {
                const t = this._root.querySelector(".spinner-container");
                try {
                    const t = await fetch(`${this.base_api}category?language=${this._locale}`, {
                        method: "GET",
                        headers: {Accept: "application/json"}
                    });
                    if (t) {
                        const e = await t.json();
                        this._categories = e.map((t => t.id));
                        const s = this._root.querySelector("#category-select");
                        s && (s.innerHTML = `<option value="" disabled selected>${this._translations.category}</option>${e.map((t => `<option value="${t.id}">${t.name}</option>`))}`)
                    }
                } catch (t) {
                } finally {
                    t && (t.style.display = "none"), this._isLoading = !1
                }
            }

            async _fetchBrand() {
                this._isLoading = !0;
                const t = this._root.querySelector(".spinner-container");
                t && (t.style.display = "flex");
                try {
                    const t = await fetch(`${this.base_api}category/${this._category}?language=${this._locale}`, {
                        method: "GET",
                        headers: {Accept: "application/json"}
                    });
                    if (t) {
                        const e = await t.json(), s = this._root.querySelector("#brand-select");
                        s && (s.disabled = !1, s.innerHTML = `<option value="" disabled selected>${this._translations.brand}</option>${e.map((t => `<option value="${t.id}">${t.name}</option>`))}`)
                    }
                } catch (t) {
                } finally {
                    t && (t.style.display = "none"), this._isLoading = !1
                }
            }

            async _fetchModel() {
                this._isLoading = !0;
                const t = this._root.querySelector(".spinner-container");
                t && (t.style.display = "flex");
                try {
                    const t = await fetch(`${this.base_api}category/${this._category}/make/${this._brand}?language=${this._locale}`, {
                        method: "GET",
                        headers: {Accept: "application/json"}
                    });
                    if (t) {
                        const e = await t.json(), s = this._root.querySelector("#model-select");
                        s && (s.disabled = !1, s.innerHTML = `<option value="" disabled selected>${this._translations.model}</option>${e.map((t => `<option value="${t.id}">${t.name}</option>`))}`)
                    }
                } catch (t) {
                } finally {
                    t && (t.style.display = "none"), this._isLoading = !1
                }
            }

            async _fetchType() {
                this._isLoading = !0;
                const t = this._root.querySelector(".spinner-container");
                t && (t.style.display = "flex");
                try {
                    const t = await fetch(`${this.base_api}category/${this._category}/make/${this._brand}/model/${this._model}?language=${this._locale}`, {
                        method: "GET",
                        headers: {Accept: "application/json"}
                    });
                    if (t) {
                        const e = await t.json(), s = this._root.querySelector("#type-select");
                        s && (s.disabled = !1, s.innerHTML = `<option value="" disabled selected>${this._translations.type}</option>${e.map((t => `<option value="${t.id}">${t.name}</option>`))}`)
                    }
                } catch (t) {
                } finally {
                    t && (t.style.display = "none"), this._isLoading = !1
                }
            }

            async _fetchResult() {
                this._isLoading = !0;
                const t = this._root.querySelector(".spinner-container");
                t && (t.style.display = "flex");
                try {
                    const t = await fetch(`${this.base_api}category/${this._category}/make/${this._brand}/model/${this._model}/type/${this._type}?language=${this._locale}`, {
                        method: "GET",
                        headers: {Accept: "application/json"}
                    });
                    if (t) {
                        const e = await t.json(), s = this._root.querySelector("#results-btn"),
                            i = this._root.querySelector("#results");
                        if (s && e?.link) {
                            s.style.display = "none"; i.style.display = "block"; i.href = e.link; i.target = "_blank";
                        } else if (s) {
                            s.innerHTML = this._translations.no_result || "Kein Ergebnis gefunden"; s.disabled = true;
                        }
                    }
                } catch (t) {
                } finally {
                    t && (t.style.display = "none"), this._isLoading = !1
                }
            }
        }

        return customElements.get("of-widget") || customElements.define("of-widget", s), t.WDWidget = s, t
    }({});
//# sourceMappingURL=simple-send.bundle.js.map
}